
function Price(quantities, fares) {
  console.log('PRICE quantities', quantities);
  console.log('PRICE fares', fares);
  this.quantities = quantities;
  this.fares = fares;
}

Price.prototype.total = function() {
  return this.quantities.reduce((acc, cur) => {
    // console.log('this.fares', this.fares);
    const tix = this.fares.find(o => o.id === cur.id);
    const subTotalPrice = parseFloat(tix.price) * cur.quantity;
    return acc + subTotalPrice;
  }, 0);
}

Price.prototype.adult = function() {
  const objs = _.filter(this.quantities, q => { return q.id === 'adult' || q.id === 'group_adult' });
  const obj = _.find(objs, q => { return q.quantity > 0 });
  const price = obj && _.find(this.fares, f => { return f.id === obj.id });
  return obj ? price.price : 0;
}

Price.prototype.child = function() {
  const objs = _.filter(this.quantities, q => { return q.id === 'child' || q.id === 'group_child' });
  const obj = _.find(objs, q => { return q.quantity > 0 });
  const price = obj && _.find(this.fares, f => { return f.id === obj.id });
  return obj ? price.price : 0;
}

Price.prototype.savings = function() {
  const packageTix = _.reduce(this.quantities, (acc, cur) => {
    const tix = this.fares.find(o => o.id === cur.id);
    const subTotalPrice = parseFloat(tix.price) * cur.quantity;
    return acc + subTotalPrice;
  }, 0);
}

Price.prototype.group = function() {
  const groupAdultI = this.fares.findIndex(t => t.id === 'group_adult');
  const groupChildI = this.fares.findIndex(t => t.id === 'group_child');
  const adultPrice = parseInt(this.fares[groupAdultI]['price']).toFixed(2);
  const childPrice = parseInt(this.fares[groupChildI]['price']).toFixed(2);

  return {
    adult: {
      price: adultPrice,
      priceTag: '£' + adultPrice
    },
    child: {
      price: childPrice,
      priceTag: '£' + childPrice
    }
  };
}
// export const prices = (quantities, fares) => {
//   console.log('quantities', quantities);
//   console.log('fares', fares);
//   return quantities.reduce((acc, cur) => {
//     const tix = fares.find(o => o.id === cur.id);
//     const subTotalPrice = parseFloat(tix.price) * cur.quantity;
//     return acc + subTotalPrice;
//   }, 0);
// }

export default Price;
